import TokenEditor from "./TokenEditor";
import TokenEditorModal from "./TokenEditorModal";
import { EditorMode } from "shared/enums/EditorModeEnum";
import CreateOrUpdateTokenSuccessPopup from "./CreateOrUpdateTokenSuccessPopup";
import { useState } from "react";

interface Props {
  onClose?: () => void;
}

export default function CreateTokenPopup(props: Props) {
  const { onClose } = props;
  const [isCreateTokenSuccess, setIsCreateTokenSuccess] = useState(false);
  const handleTokenCreateSuccess = () => {
    setIsCreateTokenSuccess(true);
  };

  const handleTokenCreateSuccessClose = () => {
    onClose?.();
  };

  return (
    <>
      {!isCreateTokenSuccess && (
        <TokenEditorModal title="Create New Token" onClose={() => onClose?.()}>
          <TokenEditor
            mode={EditorMode.Create}
            onCancel={() => onClose?.()}
            onTokenCreateSuccess={handleTokenCreateSuccess}
          />
        </TokenEditorModal>
      )}
      {isCreateTokenSuccess && (
        <CreateOrUpdateTokenSuccessPopup onClose={handleTokenCreateSuccessClose} />
      )}
    </>
  );
}
